export default {
  apiKey: 'AIzaSyBZKDIcqQFnDAL8VH9SyH8lzQNOnvEtnaE',
  authDomain: 'mosala-1ad24.firebaseapp.com',
  databaseURL: 'https://mosala-1ad24.firebaseio.com',
  projectId: 'mosala-1ad24',
  storageBucket: 'mosala-1ad24.appspot.com',
  messagingSenderId: '259689580455'
};


// WEBPACK FOOTER //
// ./src/api/firebaseConfig.js